module.exports = __webpack_public_path__ + "static/Trio-63ed5f4469d027ab4bf3eab3c5ef8685.png";